import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule, ModalModule } from 'snl-complib';
import { TYPEOFCOA } from 'src/app/constant/constant';

@Component({
  selector: 'app-change-coa-type-popup',
  standalone: true,
  imports: [ModalModule, ButtonModule, NgClass],
  templateUrl: './change-coa-type-popup.component.html',
  styleUrl: './change-coa-type-popup.component.scss'
})
export class ChangeCoaTypePopupComponent {
  disableSaveButton:boolean = true;
  showErrorMessage: boolean = false;
  modalSettings: any;
  typeOfCoa: any = TYPEOFCOA;

  @Input() open: boolean = false;
  @Input() coaType: string = '';
  @Output() onButtonClick: EventEmitter<any | null> = new EventEmitter();

  ngOnInit(){
    this.modalSettings = { showCloseIcon: true, backdropClick: false };
  }

  closeModalPopUp() {
    this.onButtonClick.emit({}) 
  }

  changeCoaType(event: any) {
    this.onButtonClick.emit(event) 
  }
}
